import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Row } from 'reactstrap';
import CountUp from 'react-countup';
import { fetchNotificationLogSummary } from '../action/action';

const StatusSummaryCards = ({ dateFrom, dateTo }) => {
  const dispatch = useDispatch();
  const { logSummary } = useSelector((state) => state.notificationManager);

  const getSummary = useCallback(async (params) => {
    await fetchNotificationLogSummary({ params, dispatch });
  }, [dispatch]);

  useEffect(() => {
    getSummary({ filter: { dateFrom, dateTo } });
  }, [dateFrom, dateTo, getSummary]);

  const total = logSummary?.total || 0;
  const success = logSummary?.success || 0;
  const failed = logSummary?.failed || 0;

  const cards = [
    {
      label: 'Total Notifications',
      value: total,
      bg: '#e6f0ff',
      color: '#1170ff',
      icon: 'bx-bell',
    },
    {
      label: 'Success',
      value: success,
      bg: '#e6f9f4',
      color: '#50c0a8',
      icon: 'bx-check-circle',
    },
    {
      label: 'Failed',
      value: failed,
      bg: '#fff4f6',
      color: '#e15e7d',
      icon: 'bx-x-circle',
    },
  ];

  return (
    <Row className="mt-4">
      {cards.map((card) => (
        <Col md={4} key={card.label}>
          <Card
            className="card-h-100 border shadow-sm"
            style={{ borderRadius: '12px', borderColor: '#e9e9ef' }}
          >
            <CardBody className="p-4">
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <span className="text-muted mb-2 lh-1 d-block text-truncate font-size-14">
                    {card.label}
                  </span>
                  <h4 className="mb-0">
                    <span className="counter-value">
                      <CountUp end={parseInt(card.value, 10)} duration={2} />
                    </span>
                  </h4>
                </div>
                <div
                  className="avatar-md text-center"
                  style={{
                    backgroundColor: card.bg,
                    color: card.color,
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                  }}
                >
                  <i className={`bx ${card.icon}`}></i>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatusSummaryCards;
